export default __webpack_public_path__ + "static/media/dark-logo.2899606c.png";